import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetCandidate, GetCandidateInJobOffer } from '../models/candidate/get-candidate';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Paged } from '../models/shared/paged';
import { HttpUtil } from '../utils/http-util';
import { GetFreelancerFilter, GetUserFilter } from '../models/security/get-user-filter';
import { ApplicationStatusEnum } from '../enums/application-status.enum';

@Injectable({
  providedIn: 'root'
})
export class CandidateService {

  constructor(
    private _http: HttpClient
  ) { }

  public getCandidate(): Observable<GetCandidate> {
    return this._http.get<GetCandidate>(`${environment.api.url}/User/GetAllCandidate`);
  }

  public getCandidateById(userId: number): Observable<GetCandidate> {
    return this._http.get<GetCandidate>(`${environment.api.url}/User/Candidate/${userId}`);
  }

  public getIndependentProfessionals(filter: GetFreelancerFilter): Observable<Paged<GetCandidate>> {
    return this._http.get<Paged<GetCandidate>>(`${environment.api.url}/User/IndependentProfessional`, {
      params: HttpUtil.toHttpParams(filter)
    });
  }

  public getCandidatesInJobOffer(filter: GetUserFilter): Observable<Paged<GetCandidateInJobOffer>> {
    return this._http.get<Paged<GetCandidateInJobOffer>>(`${environment.api.url}/User/CandidatesInJobOffer`, {
      params: HttpUtil.toHttpParams(filter)
    });
  }
  
  public getIndependentProfessionalsById(userId: number): Observable<GetCandidate> {
    return this._http.get<GetCandidate>(`${environment.api.url}/User/IndependentProfessional/${userId}`);
  }
  
}
